<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row justify-content-center">
            <bita-input
              ref="name"
              type="text"
              name="name"
              label="نام ترمینال"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />

            <bita-select
              id="statuses"
              name="statuses"
              label="وضعیت"
              ref="statuses"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="statuses"
              data-text-field="title"
              data-value-field="value"
              v-model="form.status"
            />
            <bita-select
              id="originstate"
              name="state"
              label="استان"
              ref="state"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="state"
              data-text-field="name"
              data-value-field="id"
              v-model="form.state_id"
              @change="(e) => this.getCity(e)"
            />
            <Spinner
              :is-loading="isLoadingCities"
              class-name="col-12"
              styleName="align-self: center;"
            />
            <bita-multiselect
              v-if="this.isLoadingCities === false"
              name="cities"
              label="شهر"
              ref="city"
              rules="required"
              validation-container-class="col-12"
              input-class="form-control"
              :data-source="cities"
              data-text-field="name"
              data-value-field="id"
              v-model="form.city_ids"
            />
          </div>
        </div>
      </bita-form>
      <div slot="footer" class="d-flex flex-column flex-md-row">
        <div class="p-md-0 col-12 col-md-2" v-if="!propsData.id">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2" v-if="propsData.id">
          <bita-bootbutton
            type="primary"
            title="بروزرسانی"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-4 mr-md-5">
          <bita-bootbutton
            class="w-100 bg-transparent border-0 text-danger"
            type="danger"
            title="بستن"
            icon="fas fa-times"
            data-dismiss="modal"
            @click.native="
              () => {
                $emit('change-status-modal');
              }
            "
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";

export default {
  components: { Spinner, MultiSelect },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
      },
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      state: [],
      isLoadingCities: false,
      cities: [],
      form: {},
      statuses: [
        {
          title: "فعال",
          value: 1,
        },
        {
          title: "عدم دسترسی",
          value: 2,
        },
        {
          title: "غیرفعال",
          value: 3,
        },
      ],
    };
  },
  watch: {
    propsData: function(_data) {
      this.form = {
        id: _data.id,
        name: _data.name,
        status: _data.status,
        state_id: null,
        city_ids: [],
      };

      // if (_data.cities && _data.cities.length)
      _data.cities.forEach((el) => {
        if (el.parent_id == 0) {
          this.form.state_id = el.id;
          this.getCity(this.form.state_id);
        } else {
          this.form.city_ids.push(el.id);
        }
      });
    },
  },
  mounted() {
    this.getState();
  },
  methods: {
    getState() {
      this.$persistClient("get", "cities?filter[province]=0")
        .then((res) => {
          this.state = res.data;
        })
        .finally(() => {});
    },
    getCity(stateId) {
      this.isLoadingCities = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.cities = res.data;
        })
        .finally(() => {
          this.isLoadingCities = false;
        });
    },
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      this.$refs.form.reset();
    },
  },
};
</script>
